import React from 'react'
import { TableHead, TableRow, TableCell } from 'transfix-ui'
import { SPOT_BIDDING_CONFIGS_COLUMNS } from '../types/spotBiddingConfig'

export const SpotBiddingConfigsHeader = () => {
  return (
    <TableHead>
      <TableRow tableCellType='th'>
        {Object.entries(SPOT_BIDDING_CONFIGS_COLUMNS).map(([key, value]) => (
          <TableCell
            dataTest={`${key}-column-header`}
            key={`${key}-column-header`}
            tableCellType='th'>
            {value}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}
